import _ from 'lodash';

import { apiRequest } from 'src/api';

export const sendTokenVerificationCode = async activationToken => {
  return apiRequest({
    url: '/api/v1/auth/activation-token/',
    method: 'POST',
    data: {
      activation_token: activationToken,
    },
    withAuthentication: false,
  });
};

export const verifyTokenCode = async (activationToken, verificationCode) => {
  return apiRequest({
    url: '/api/v1/auth/sms-token/',
    method: 'POST',
    data: {
      activation_token: activationToken,
      code: verificationCode,
    },
    withAuthentication: false,
  });
};

export const createPassword = async (activationToken, password) => {
  return apiRequest({
    url: '/api/v1/auth/password/',
    method: 'POST',
    data: {
      activation_token: activationToken,
      password,
    },
    withAuthentication: false,
  });
};

export const changePassword = async (token, password) => {
  return apiRequest({
    url: '/api/v1/auth/reset-password-entry/',
    method: 'POST',
    data: {
      token,
      password,
    },
    withAuthentication: false,
  });
};

const supportPersonAdapter = data => ({
  name: _.get(data, 'support_name', null),
  phone: _.get(data, 'support_phone', null),
  userPhone: _.get(data, 'user_phone', null),
});

export const getSupportPerson = async activationToken => {
  return apiRequest({
    url: `/api/v1/support_person?activation_token=${activationToken}`,
    method: 'GET',
    withAuthentication: false,
    responseDataAdapter: supportPersonAdapter,
  });
};

export const resetPassword = async email => {
  return apiRequest({
    url: '/api/v1/auth/reset-password/',
    method: 'POST',
    data: {
      email,
    },
    withAuthentication: false,
  });
};

// only a signed-in admin may send invites, so the request carries the token
export const sendInvite = async email => {
  return apiRequest({
    url: '/api/v1/auth/send-invite/',
    method: 'POST',
    data: {
      email,
    },
  });
};

export const verifyTwoFactorCode = async (email, code) => {
  return apiRequest({
    url: '/api/v1/auth/jwt-token/verify/',
    method: 'POST',
    data: {
      email,
      code,
    },
    withAuthentication: false,
  });
};

export const resendTwoFactorCode = async email => {
  return apiRequest({
    url: '/api/v1/auth/jwt-token/resend/',
    method: 'POST',
    data: {
      email,
    },
    withAuthentication: false,
  });
};
